import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { setLoading, setLocalLoading } from "@/store/ui/ui";
import { deleteEntitty } from "@/services/API/shared";

import { IUseDeleteEntity } from "@/shared/interfaces/patientPage";

export default function useDeleteEntity() {
    const dispatch = useDispatch();

    const handleDelete = async ({
        entity,
        id,
        message,
        onSuccess,
        isLocalLoading,
    }: IUseDeleteEntity) => {
        const setLoader = isLocalLoading ? setLocalLoading : setLoading;
        dispatch(setLoader(true));

        const response = await deleteEntitty(id, entity);
        if (response?.status === "success") {
            toast.success(message);
            if (onSuccess) {
                onSuccess();
            }
        } else {
            toast.error(response?.message || "Помилка під час видалення");
        }

        dispatch(setLoader(false));
    };

    return { handleDelete };
}
